module.exports = __webpack_public_path__ + "static/media/check_circle_icon.500dfea3.svg";